export const WIZARD_STAGES = [
  { id: "recipient", label: "Отримувач" },
  { id: "presentation", label: "Презентація" },
  { id: "media", label: "Медіа" },
  { id: "contact", label: "Контакти і доступ" },
];

export const WIZARD_PROGRESS = [
  ...WIZARD_STAGES,
  { id: "review", label: "Перевірка" },
];

export const STAGE_FIELD_KEYS = {
  recipient: ["client", "internal_label"],
  presentation: [
    "price_mode",
    "custom_price",
    "custom_currency",
    "location_precision",
    "presentation_note",
  ],
  media: ["media", "include_video"],
  contact: [
    "contact_phone",
    "contact_email",
    "include_contact_avatar",
    "expires_at",
  ],
};

export function stageIndexForFieldErrors(errors) {
  if (!errors || typeof errors !== "object") return 0;
  const keys = Object.keys(errors).filter((key) => key !== "_form");
  const index = WIZARD_STAGES.findIndex((stage) => {
    const stageKeys = STAGE_FIELD_KEYS[stage.id] || [];
    return keys.some((key) => stageKeys.includes(key));
  });
  return index >= 0 ? index : 0;
}

export function pickStageErrors(errors, stageId) {
  const keys = STAGE_FIELD_KEYS[stageId] || [];
  const next = {};
  keys.forEach((key) => {
    if (errors[key]) next[key] = errors[key];
  });
  return next;
}

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function getFocusableElements(root) {
  if (!root || typeof root.querySelectorAll !== "function") return [];
  return Array.from(root.querySelectorAll(FOCUSABLE_SELECTOR)).filter((node) => {
    return node.getAttribute("aria-hidden") !== "true";
  });
}

export function containTabKey(event, root) {
  if (!event || event.key !== "Tab" || !root) return;
  const items = getFocusableElements(root);
  if (!items.length) {
    event.preventDefault();
    return;
  }
  const first = items[0];
  const last = items[items.length - 1];
  const active = document.activeElement;
  const inside = root.contains(active);
  if (event.shiftKey) {
    if (!inside || active === first) {
      event.preventDefault();
      last.focus();
    }
    return;
  }
  if (!inside || active === last) {
    event.preventDefault();
    first.focus();
  }
}

export function WizardProgress({ currentIndex }) {
  return (
    // Explicit role="list": list-style:none strips implicit list role in WebKit.
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ol
      className="ap-stepper presentation-wizard"
      role="list"
      aria-label="Кроки створення"
      data-testid="presentation-wizard"
    >
      {WIZARD_PROGRESS.map((item, index) => {
        const isCurrent = index === currentIndex;
        const isDone = index < currentIndex;
        const stateClass = isCurrent
          ? "is-active"
          : isDone
            ? "is-done"
            : "is-upcoming";
        return (
          <li
            key={item.id}
            className={`ap-step presentation-wizard__step ${stateClass}${isCurrent ? " is-current" : ""}`}
            aria-current={isCurrent ? "step" : undefined}
          >
            <span className="ap-step__btn presentation-wizard__btn">
              <span className="ap-step__num presentation-wizard__index" aria-hidden="true">
                {index + 1}
              </span>
              <span className="ap-step__label">{item.label}</span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
